'use strict';

/**
* @ngdoc service
* @name tcApp.WebsysListLegacyScope
* @description
* Contains systemUI equivalents for legacy functions originally defined in websys.list.js & websys.list.tools.js
*
*/
angular.module('tc.legacyScope').factory('WebsysListLegacyScope', function($window, $log, tcConstants, LegacyScopeTweakService,
													LegacyScopeSearchService, OverlayService, ComponentListService) {
	
	/* eslint no-unused-vars:0 */
	return function($scope, legacyScopeObject, legacyFunctions) {
		var emptyFunction = function() {
		};
		
		var selectRow = function() {
			$log.warn($scope.componentName, ': Call to SelectRow');
			return false;
		};
		
		// Highlight a specific row when loading or reloading a component
		var highlightRowOnLoad = function(id) {
			if (angular.isUndefined($scope.data.listData)) return;
			if (!$scope.data.listData.allowMultiSelect) return;
			if ((!id) || (id === '')) return;
			
			var rowIndex = id.substr(id.lastIndexOf('z') + 1, id.length);
			if (rowIndex === '') return;
			rowIndex -= 1;
			$scope.viewModel.listSettings.selectMode = true;
			$scope.viewModel.listSettings.selectedRows[$scope.data.listData.pageCount - 1][rowIndex] = true;
			if ((angular.isDefined($scope.data.listRows))
				&& (angular.isDefined($scope.data.listRows[rowIndex]))) {
				$scope.selectRowHandler(null, true, $scope.data.listRows[rowIndex]);
			}
		};
		
		/*
		* @ngdoc method
		* @name websys_toggleRowSelected
		* @methodOf tcapp.WebsysListLegacyScope
		* @param {Object} Options object with properties:
		* - id:                  The list row id
		* - selected [Optional]: Can be passed in, to set select or unselect the row;
		*                                        otherwise, the current row select status will be toggled. 
		*                                        Do not use the status toggle inside of the row select handler, it will cause infinite loop. 
		*                                        To avoid infinite loop, the selected parameter should be passed in.
		* @description
		* A method to toggle the row select status
		*/
		var websysToggleRowSelected = function(options) {
			options = options || {};
			if (angular.isUndefined($scope.data.listData)) return;
			if (!$scope.data.listData.allowMultiSelect) return;
			if ((!angular.isString(options.id)) || (options.id === '')) return;
			
			var rowId = options.id;
			var rowIndex = rowId.substring(rowId.lastIndexOf('z') + 1, rowId.lastIndexOf('z') + 1 + rowId.length);
			if (rowIndex === '') return;
			rowIndex -= 1;
			
			var isSelected = options.selected;
			if (typeof isSelected !== 'boolean') {
				// if options.selected is not passed in or the passed in data type is not boolean, toggle the row select status, 
				// only use this when this function is not triggered inside of the row select handler,
				// otherwise it can cause infinite loop
				isSelected = !($scope.viewModel.listSettings.selectedRows[$scope.data.listData.pageCount - 1][rowIndex]);
			} else if (($scope.viewModel.listSettings.selectedRows[$scope.data.listData.pageCount - 1][rowIndex]===isSelected)) {
				// if options.selected is passed in and its same as the current row select status, nothing needs to be done
				return;
			}

			if ((isSelected) && (!$scope.viewModel.listSettings.selectMode)) {
				$scope.viewModel.listSettings.selectMode = true;
			}
			$scope.viewModel.listSettings.selectedRows[$scope.data.listData.pageCount - 1][rowIndex] = isSelected;
			if ((angular.isDefined($scope.data.listRows))
				&& (angular.isDefined($scope.data.listRows[rowIndex]))) {
				$scope.selectRowHandler(null, isSelected, $scope.data.listRows[rowIndex]);
			}
		};
		
		// Returns a object respresenting the table for the component
		var getTable = function() {
			return legacyScopeObject.getDocument($scope).getElementById('t' + $scope.componentHtmlName);
		};
		
		// Returns the values of table items for selected rows
		// Item is an object with keys of table item names, which gets modified
		var tkGetDataSelRows = function(table, checkboxName, items) {
			if (angular.isUndefined($scope.data.listRows)) return items;
			
			if ((checkboxName) && (checkboxName.toUpperCase().indexOf('SELECT') !== -1)) {
				if (!$scope.data.listData.allowMultiSelect) return items;
				if (!$scope.viewModel.listSettings.selectMode) return items;
				
				var itemCount = 0;
				var currentPage = ($scope.data.listData.pageCount - 1);
				angular.forEach($scope.viewModel.listSettings.selectedRows[currentPage],
					function(rowSelected, listRowIndex) {
						if ((rowSelected) && ($scope.data.listRows[listRowIndex])) {
							for (var itemId in items) {
								if (angular.isDefined($scope.data.listRows[listRowIndex][itemId])) {
									items[itemId][itemCount] = $scope.data.listRows[listRowIndex][itemId].value;
								}
							}
							itemCount++;
						}
					}
				);
			} else {
				$log.warn($scope.componentName, 'tk_getDataSelRows: Non standard select item');
			}
			return items;
		};
		
		// Returns the window object
		var eprGetTopWindow = function() {
			return $window;
		};
		
		// Returns the form object
		var getFrmFromTbl = function(table) {
			return legacyScopeObject.getDocument($scope).getElementById('f' + $scope.componentHtmlName);
		};
		
		var setRowSelected = function() {
			$log.warn($scope.componentName, ': Call to setRowSelected');
		};
		
		var setRowClear = function() {
			$log.warn($scope.componentName, ': Call to setRowClear');
		};
		
		// In TC UI, this function expects a row object
		// in ME UI, we allow either a row or item object
		var websysGetRowIndex = function(rowOrItemObj, getTreeRowIndex) {
			if (angular.isUndefined(rowOrItemObj)) return undefined;
			var listRowIndex;
			
			if (angular.isUndefined(rowOrItemObj._listRowIndex)) {
				// Handle row object, get the rowIndex of the first item
				var firstItemName = LegacyScopeSearchService.getFirstItemKey(rowOrItemObj);
				if ((firstItemName) && (angular.isDefined(rowOrItemObj[firstItemName]._listRowIndex))) {
					rowOrItemObj = rowOrItemObj[firstItemName];
				}
			}
			if (angular.isDefined(rowOrItemObj)) {
				if ((getTreeRowIndex) && (angular.isDefined(rowOrItemObj._nestedLevel))) {
					// When called via websys_getTreeRowIndex:
					// For nested tree rows, construct the row index by traversing through previous levels
					var thisLevel;
					var rowIndices = [];
					var currentLevel = rowOrItemObj._nestedLevel;
					var currentLevelCount = 0;
					if (angular.isDefined($scope.data.listRows)) {
						// Go from current row to the first row
						for (listRowIndex = rowOrItemObj._listRowIndex; listRowIndex > -1; listRowIndex--) {
							thisLevel = ($scope.data.listRows[listRowIndex]._nestedLevel || 0);
							// Ignore rows for higher levels
							if (thisLevel == currentLevel) {
								currentLevelCount = currentLevelCount + 1;
							} else if (thisLevel < currentLevel) {
								// Found a lower level, add the counter and reset
								rowIndices.push(currentLevelCount);
								currentLevel = thisLevel;
								currentLevelCount = 1;
							}
						}
						if (currentLevelCount > 0) rowIndices.push(currentLevelCount);
					}
					// Leaf index then indices from highest to lowest level
					return (rowIndices.slice(0, 1) + '_' + rowIndices.slice(1).reverse().join('_'));
				} else {
					if (getTreeRowIndex) {
						// When called via websys_getTreeRowIndex:
						// Add list row indices, filter out everything except the top level, then return the top level index
						var topLevelRows = $scope.data.listRows.map(function(listRow, listRowIndex) {
							listRow._listRowIndex = listRowIndex;
							return listRow;
						}).filter(function(listRow) {
							return (angular.isUndefined(listRow._nestedLevel));
						});
						for (listRowIndex = 0; listRowIndex < topLevelRows.length; listRowIndex++) {
							if (topLevelRows[listRowIndex]._listRowIndex === rowOrItemObj._listRowIndex) break;
						}
						return (listRowIndex + 1);
					} else {
						return (rowOrItemObj._listRowIndex + 1);
					}
				}
			}
			
			return undefined;
		};
		
		var websysGetTreeRowIndex = function(rowOrItemObj) {
			return websysGetRowIndex(rowOrItemObj, true);
		};
		
		// returns 0 indexed listRowIndex
		var websysGetSectionRowIndex = function(rowOrItemObj) {
			if (angular.isUndefined(rowOrItemObj)) return undefined;
			
			if (angular.isDefined(rowOrItemObj._listRowIndex)) {
				// Handle item object
				return (rowOrItemObj._listRowIndex);
			} else {
				// Handle row object, get the rowIndex of the first item
				var firstItemName = LegacyScopeSearchService.getFirstItemKey(rowOrItemObj);
				if ((firstItemName) && (angular.isDefined(rowOrItemObj[firstItemName]._listRowIndex))) {
					return (rowOrItemObj[firstItemName]._listRowIndex);
				}
			}
			return undefined;
		};
		
		// Toggles the visibility of the list section of a component.
		// 'visibility' can be passed to manually set the list to visible/hidden
		var websysToggleList = function(visibility) {
			if (angular.isDefined(visibility)) {
				$scope.viewModel.listSettings.hideList = !visibility;
			} else {
				$scope.viewModel.listSettings.hideList = !$scope.viewModel.listSettings.hideList;
			}
			return;
		};
		
		// Returns an array of objects representing list cells for a list row
		var websysGetListCells = function(listRow) {
			if (angular.isUndefined($scope.data.listRows)) return [];
			if (!angular.isObject(listRow)) return [];
			
			var listCells = [];
			angular.forEach(listRow, function(item, itemName) {
				if (!LegacyScopeTweakService.isListRowMetaData(itemName)) {
					listCells.push(item);
				}
			});
			return listCells;
		};
		
		// Returns a object respresenting a list row, given a table item
		var getRow = function(item) {
			var rowIndex;
			if ((angular.isDefined(item)) && (angular.isDefined(item._listRowIndex))) {
				rowIndex = item._listRowIndex;
			}
			var listRow = $scope.data.listRows[rowIndex];
			if (angular.isUndefined(listRow)) return;
			
			// Only return the properties that are used in scripts
			// We might need to return the whole row data?
			return {
				_listRowIndex: rowIndex,
				_nestedLevel: listRow._nestedLevel,
				_hidden: listRow._hidden,
				rowIndex: rowIndex,
				sectionRowIndex: rowIndex,
				style: {'cssText': ''},
				TRAKListIndex: rowIndex,
				cells: websysGetListCells(listRow)
			};
		};
		
		// Returns an array of objects representing list rows
		var websysGetListRows = function(list, skipHeader) {
			if (angular.isUndefined($scope.data.listRows)) {
				return [];
			}
			var listRows = angular.copy($scope.data.listRows);
			if (!skipHeader) {
				// Add an extra row at the start for the list header
				listRows.unshift({
					_listRowIndex: 0,
					id: '',
					cells: [],
					getElementsByTagName: function() {
						return [];
					}
				});
			}
			angular.forEach(listRows, function(listRow, listRowIndex) {
				if ((!skipHeader) && (listRowIndex === 0)) return;
				
				listRow._listRowIndex = listRowIndex;
				listRow.id = '';
				listRow.cells = websysGetListCells(listRow);
				listRow.getElementsByTagName = function(tagName) {
					return legacyScopeObject.getElementsByTagName($scope.data, tagName, true, listRowIndex);
				};
			});

			return listRows;
		};
		
		// Just return the item wrapped in an array
		var websysGetListCellChildren = function(item) {
			if (!item) return null;
			
			return [item];
		};
		
		// Disables all items on a list row
		var websysListDisableRow = function(listRow) {
			if (angular.isUndefined(listRow)) return;
			var listRowIndex = listRow._listRowIndex;
			if (angular.isUndefined(listRowIndex)) return;
			if (angular.isUndefined($scope.data.listRows)) return;
			// Get the scope object instead of the emulated row object
			listRow = $scope.data.listRows[listRowIndex];
			if (angular.isUndefined(listRow)) return;
			
			angular.forEach(listRow, function(item, itemName) {
				if ((!LegacyScopeTweakService.isListRowMetaData(itemName))
					&& (!item.hiddenItem) && (!item.displayOnly)) {
					legacyFunctions.DisableField('', false, item);
				}
			});
			if ($scope.data.listData.allowMultiSelect) {
				listRow['_selectDisabled'] = true;
				listRow['_selected'] = false;
			}
			// Also deselect the row
			if (($scope.data.listData.allowMultiSelect) && ($scope.viewModel.listSettings.selectMode)) {
				var currentPage = ($scope.data.listData.pageCount - 1);
				$scope.viewModel.listSettings.selectedRows[currentPage][listRowIndex] = false;
				$scope.selectRowHandler(null, false, listRow);
			}
		};
		
		// Returns an array of (1-indexed) row indices for the selected rows of the table
		var checkedCheckBoxes = function() {
			if (angular.isUndefined($scope.data.listRows)) return [];
			if (!$scope.data.listData.allowMultiSelect) return [];
			if (!$scope.viewModel.listSettings.selectMode) return [];
			
			var found = [];
			var currentPage = ($scope.data.listData.pageCount - 1);
			if (($scope.viewModel.listSettings)
			&& ($scope.viewModel.listSettings.selectedRows)
			&& ($scope.viewModel.listSettings.selectedRows[currentPage])) {
				angular.forEach($scope.viewModel.listSettings.selectedRows[currentPage],
					function(selectedRow, listRowIndex) {
						if (selectedRow) found.push(parseInt(listRowIndex) + 1);
					}
				);
			}
			
			// Add any selected nested list rows for nested tree components
			if ((angular.isDefined($scope.viewModel.listSettings.selectedNestedRows))
				&& (angular.isDefined($scope.viewModel.listSettings.selectedNestedRows[currentPage]))) {
				angular.forEach($scope.viewModel.listSettings.selectedNestedRows[currentPage],
					function(selectedRow, listRowIndex) {
						if (selectedRow) {
							// Adjust array to be 1-indexed for each level
							var listRowIndexArray = listRowIndex.split('_');
							listRowIndexArray = listRowIndexArray.map(function(index) { return (Number(index) + 1);});
							found.push(listRowIndexArray.join('_'));
						}
					}
				);
			}

			return found;
		};
		
		/*
		* @ngdoc method
		* @name websysList_SetSelectRowMessageFunction
		* @methodOf tcapp.WebsysListLegacyScope
		* @param {Object} listRow - required list row object
		* @description
		* for TCUI, a row highlight is considered selected (for passing to header menu),
		*  but MEUI does not have that equivalency and only checks on select checkbox 
		*  (MEUI _active highlight is considered different action)
		* @returns {Boolean} Returns true if the listRow is considered selected
		*/
		var websysListIsRowSelected = function(listRow) {
			return (($scope.viewModel.listSettings.selectMode) && (listRow._selected));
		};
		
		/*
		* @ngdoc method
		* @name websysList_SetSelectRowMessageFunction
		* @methodOf tcapp.WebsysListLegacyScope
		* @param {String} functionName - required function name within component scope
		* @description
		* assign a function to a component list to be executed upon row selection for prompts / warnings, etc
		*  will be called before SelectRowHandler
		* when the function is executed, expects a message object with options object
		* - messageText: [required] Text of the message that will display.
		* - messageType: [required] Type of the message. 'E' (Error), 'W' (Warning) and 'I' (Info) are supported.
		*/
		var websysListSetSelectRowMessageFunction = function(functionName) {
			$scope.viewModel.listSettings.selectRowMessageFunc = null;
			if (functionName === '') return;
			if (!angular.isFunction($scope[functionName])) {
				$log.warn($scope.componentName,'SelectRowMessageFunction \''+functionName+ '\' is not a scoped function');
				return;
			}
			$scope.viewModel.listSettings.selectRowMessageFunc = $scope[functionName];
		};
		
		// Fixes the indices for the items on a list row
		var fixRowIndices = function(listRowIndex) {
			angular.forEach($scope.data.listRows[listRowIndex], function(item, itemName) {
				if (!LegacyScopeTweakService.isListRowMetaData(itemName)) {
					// Reset '_listRowIndex' and 'id' attributes
					LegacyScopeTweakService.extendItemObject(itemName, item, listRowIndex);
				}
			});
		};
		
		// Moves row data in the specified direction, given a table item. Defaults to down
		var moveRow = function(item, direction) {
			if ((angular.isUndefined(item)) || (angular.isUndefined(item._listRowIndex))) {
				$log.warn($scope.componentName, 'moveRow: Invalid item');
				return;
			}
			var listRowIndex = item._listRowIndex;
			if (angular.isUndefined($scope.data.listRows)) return;
			if (angular.isUndefined($scope.data.listRows[listRowIndex])) return;
			
			var rowDataToReplace;
			if (direction === 'U') {
				if (listRowIndex > 0) {
					// Note that 'tkRow' variable used by any OnChange/Link functions will not be changed
					rowDataToReplace = $scope.data.listRows[listRowIndex - 1];
					$scope.data.listRows[listRowIndex - 1] = $scope.data.listRows[listRowIndex];
					$scope.data.listRows[listRowIndex] = rowDataToReplace;
					fixRowIndices(listRowIndex - 1);
					fixRowIndices(listRowIndex);
				}
			} else {
				if (listRowIndex < $scope.data.listRows.length) {
					rowDataToReplace = $scope.data.listRows[listRowIndex + 1];
					$scope.data.listRows[listRowIndex + 1] = $scope.data.listRows[listRowIndex];
					$scope.data.listRows[listRowIndex] = rowDataToReplace;
					fixRowIndices(listRowIndex + 1);
					fixRowIndices(listRowIndex);
				}
			}
		};
		
		// Removes a row from the listRow data, given a table item
		var deleteRow = function(item) {
			if ((angular.isUndefined(item)) || (angular.isUndefined(item._listRowIndex))) {
				$log.warn($scope.componentName, 'deleteRow: Invalid item');
				return;
			}
			var rowIndexToDelete = item._listRowIndex;
			if (angular.isUndefined($scope.data.listRows)) return;
			if (angular.isUndefined($scope.data.listRows[rowIndexToDelete])) return;
			
			// When deleting the first row within a row group, move the group column data to the next row
			var groupColumn = $scope.data.listRows[rowIndexToDelete]['_groupColumn'];
			var groupColumnCount = $scope.data.listRows[rowIndexToDelete]['_groupColumnCount'];
			var nextRow = $scope.data.listRows[rowIndexToDelete + 1];
			if ((angular.isDefined(nextRow)) && (angular.isDefined(groupColumn))
				&& (nextRow['_groupColumnCount'] === groupColumnCount)) {
				nextRow['_groupColumn'] = groupColumn;
			}
			
			$scope.data.listRows.splice(rowIndexToDelete, 1);
			// Fix up the indices on the items in all the subsequent rows
			angular.forEach($scope.data.listRows, function(listRow, listRowIndex) {
				if (listRowIndex >= rowIndexToDelete) {
					fixRowIndices(listRowIndex);
				}
			});
		};
		
		// Adds a row to the listRow data.
		// table = not used in ME UI
		// options = {groupForAddition: string, expandGroup: boolean}
		//
		// By default, copies the last row. Where 'groupForAddition' is specified:
		// - Adds a row to that group by copying the last row in the group
		// - Where the group is not found, copies the last row and creates a new group
		// 'expandGroup' will expand the specified group by default on adding the row
		var addRow = function(table, options) {
			options = (options || {});
			if (angular.isUndefined($scope.data.listRows)) return;
			if (!$scope.data.listRows.length) {
				$log.warn($scope.componentName, ': AddRow requires at least one row to copy');
				return;
			}
			
			var listRow,listRowGroupLastRowIndex,groupColumnName;
			var foundRowGroup = false;
			var newGroupCaption = '';
			// If a group column is specified, find the last row in order to insert the row after it
			if ((angular.isDefined(options.groupForAddition)) && (options.groupForAddition !== '')) {
				newGroupCaption = options.groupForAddition;
				angular.forEach($scope.data.listRows, function(listRow, listRowIndex) {
					if (angular.isDefined(listRow['_groupColumn'])) {
						// The group column name is only defined in the first row of a group
						groupColumnName = listRow['_groupColumn'];
					}
					if ((angular.isDefined(groupColumnName))
						&& (angular.isDefined(listRow[groupColumnName]))
						&& (listRow[groupColumnName].value === options.groupForAddition)) {
						listRowGroupLastRowIndex = listRowIndex;
						foundRowGroup = true;
					}
				});
			}
			if (angular.isUndefined(listRowGroupLastRowIndex)) {
				listRowGroupLastRowIndex = ($scope.data.listRows.length - 1);
			}
			listRow = angular.copy($scope.data.listRows[listRowGroupLastRowIndex]);
			if (newGroupCaption !== '') {
				listRow._listRowGroupValue = newGroupCaption;
			}

			angular.forEach(listRow, function(item, itemName) {
				if ((itemName.substr(0, 2) !== '$$') && (itemName.substr(0, 1) !== '_')) {
					item._listRowIndex = (listRowGroupLastRowIndex + 1);
					// Clear out value of new items
					item.value = '';
					LegacyScopeTweakService.extendItemObject(itemName, item, item._listRowIndex);
				}
			});
			listRow['_groupColumn'] = '';
			if ((!foundRowGroup)
				&& (angular.isDefined(options.groupForAddition))
				&& (options.groupForAddition !== '')) {
				listRow['_groupColumn'] = $scope.data.listRows[0]['_groupColumn'];
				if (angular.isDefined(listRow[listRow['_groupColumn']])) {
					listRow[listRow['_groupColumn']].value = options.groupForAddition;
				}
				listRow['_groupColumnCount']++;
				if (angular.isUndefined($scope.viewModel.listSettings.collapsedGroups)) {
					$scope.viewModel.listSettings.collapsedGroups = [];
				}
				$scope.viewModel.listSettings.collapsedGroups[listRow['_groupColumnCount']] = !options.expandGroup;
			}
			if (angular.isDefined($scope.viewModel.listSettings.collapsedGroups)) {
				var groupCollapsed = $scope.viewModel.listSettings.collapsedGroups[listRow['_groupColumnCount']];
				if ((angular.isDefined(groupCollapsed)) && (groupCollapsed)) {
					$scope.viewModel.listSettings.collapsedGroups[listRow['_groupColumnCount']] = !options.expandGroup;
				}
			}
			
			$scope.data.listRows.splice((listRowGroupLastRowIndex + 1), 0, listRow);
			
			// Fix up the indices on the items in all the subsequent rows
			angular.forEach($scope.data.listRows, function(listRow, listRowIndex) {
				if (listRowIndex > (listRowGroupLastRowIndex + 1)) {
					fixRowIndices(listRowIndex);
				}
			});
		};
		
		// Opens CPDetails component
		var showCpDetailsInfo = function(item, careProviderId, patientId, noUnlock) {
			if (!careProviderId) return false;
			if (!patientId) patientId = '';
			
			var focusHandler = function($event) {
				var itemId = $scope.componentHtmlName + '-row-'
							+ item._listRowIndex + '-item-' + item.id.substr(0, item.id.lastIndexOf('z')) + '-link';
				var element = $window.document.getElementById(itemId);
				if (element) element.focus();
				if (angular.isDefined(item._listRowIndex)) {
					$scope.viewModel.listSettings.actionMenuRow = null;
					ComponentListService.setListActiveRow($scope, null);
					ComponentListService.setListActiveRowChain($scope, null, true);
				}
			};
			
			var params = ('&ID=' + careProviderId + '&SrcID=' + item.id + '&PatientID=' + patientId);
			if (noUnlock === '1') params += '&NOUNLOCK=1';
			if (angular.isDefined(item._listRowIndex)) {
				// Equivalent to the active row for an action menu
				$scope.viewModel.listSettings.actionMenuRow = item._listRowIndex;
				ComponentListService.setListActiveRowChain($scope, item._listRowIndex, true);
			}
			OverlayService.open({
				componentName: 'CPDetails',
				params: params,
				parentComponentName: $scope.componentName,
				focusHandler: focusHandler
			});
			
			return false;
		};
		
		// Returns true if the nested component item has data (i.e it was expanded)
		var websysListHasNestedData = function(item) {
			return ((angular.isDefined(item.componentData))
					&& (angular.isDefined(item.componentData.componentName)));
		};
		
		// to be called from list SelectRowHandler function, recursively selects/deselects all expanded child tree rows
		// if deselectParentTreeRows is passed in as true,
		// parent rows will be marked as deselected when a childe is deselected
		var websysToggleNestedRowsSelected = function(nestedListItemName, selected, deselectParentTreeRows) {
			if (angular.isDefined($scope.viewModel.listSettings)) {
				$scope.viewModel.listSettings.deselectParentTreeRows = deselectParentTreeRows;
			}
			var selectAll = function(componentHtmlName) {
				$scope.$broadcast('Component:nestedToggleSelectAll', selected, componentHtmlName);
			};
			var nestedListDataItem = LegacyScopeSearchService.getItemFromDataObject($scope, nestedListItemName);
			if ((angular.isObject(nestedListDataItem)) && (nestedListDataItem.componentData)
				&& (nestedListDataItem.componentData.componentName)) {
				var componentName = nestedListDataItem.componentData.componentName;
				$scope.$broadcast('Component:getComponentHtmlName', componentName, selectAll,
					nestedListDataItem.componentData.componentUniqueIndexPrefix);
			}	
		};
		
		/*
		* @ngdoc method
		* @name websys_toggleNestedListItem
		* @methodOf tcApp.WebsysListLegacyScope
		* @description
		* toggles (expand or collapse) a nested list table item
		* @param {Object} Options object with properties:
		* - itemName: [optional] Name of the component table item to toggle
		* - item:     [optional] Object reference to the component item to toggle
		*						 This is used first, otherwise if not provided is checked "itemName" parameter.
		*             either itemName or item must be provided, and must be a valid item within scope.
		*
		* - action:   [optional] 'EXPAND'|'COLLAPSE'
		*             if action is defined, not blank, and neither of these valus, will log warning to console and perform no action.
		*             if action is undefined or blank, the nested item will toggle to its opposite state.
		*/
		var websysToggleNestedListItem = function(options) {
			options = options || {};
			var baseMsg = ($scope.componentName + ': websys_toggleNestedListItem: ');
			var namedItem = ((angular.isString(options.itemName) && (options.itemName !== '')) ? ('\''+ options.itemName + '\'') : '');
			var item = LegacyScopeSearchService.getItemFromOptions($scope, options, false);
			if (!item) {
				$log.warn(baseMsg + 'Item ' +  namedItem + ' could not be found');
				return;
			}
			if ((item.displayType !== 'CX') || (angular.isUndefined(item._listRowIndex))) {
				$log.warn(baseMsg + 'Item ' +  namedItem + ' is not a nested list item');
				return;
			}
			
			var toggle = false;
			if (options.action === tcConstants.NESTED_LIST_EXPAND_ACTION.EXPAND) {
				toggle = (!item.expanded);
			} else if (options.action === tcConstants.NESTED_LIST_EXPAND_ACTION.COLLAPSE) {
				toggle = (!!item.expanded);
			} else if ((angular.isDefined(options.action)) && (options.action !== '') ) {
				$log.warn(baseMsg + ' action ' + ('\'' + options.action + '\'') + ' is invalid');
				return;
			} else {
				toggle = true;
				}
			if (toggle) $scope.toggleNestedComponent(null, item, false);
			return;
		};
		
		// Allow manually setting an active list row
		var websysSetListActiveRow = function(options) {
			options = options || {};
			if (angular.isUndefined(options.rowIndex)) {
				$log.warn($scope.componentName, ': websys_setListActiveRow: rowIndex parameter required');
				return;
			}
			ComponentListService.setListActiveRow($scope, options.rowIndex);
		};
		
		// Return all the functions in an object
		var websysListFunctions = {
			/* websys.js functions */
			'websys_getRowIndex': websysGetRowIndex,
			'websys_getSectionRowIndex': websysGetSectionRowIndex,
			'websys_getTreeRowIndex': websysGetTreeRowIndex,
			'websys_toggleList': websysToggleList,
			
			/* websys.list.js functions */
			'HighlightRow_OnLoad': highlightRowOnLoad,
			'getRow': getRow,
			'getTable': getTable,
			'tk_getDataSelRows': tkGetDataSelRows,
			'EPR_getTopWindow': eprGetTopWindow,
			'getFrmFromTbl': getFrmFromTbl,
			'getFormName': getFrmFromTbl,
			'websys_getListRows': websysGetListRows,
			'websys_getListCells': websysGetListCells,
			'websys_getListCellChildren': websysGetListCellChildren,
			'websysList_disableRow': websysListDisableRow,
			'websys_toggleNestedRowsSelected': websysToggleNestedRowsSelected,
			'websys_toggleNestedListItem': websysToggleNestedListItem,
			'websys_setListActiveRow': websysSetListActiveRow,
			'websys_toggleRowSelected': websysToggleRowSelected,
			
			/* websys.list.tools.js functions */
			'getTableName': getTable,
			'checkedCheckBoxes': checkedCheckBoxes,
			'CheckedCheckBoxesOrSelectedRow': checkedCheckBoxes,
			'websysList_IsRowSelected': websysListIsRowSelected,
			'websysList_SetSelectRowMessageFunction': websysListSetSelectRowMessageFunction,
			'tk_getRow': getRow,
			'tk_getTBody': getTable,
			'MoveRow': moveRow,
			'DeleteRow': deleteRow,
			'AddRow': addRow,
			'ShowCPDetails_Info': showCpDetailsInfo,
			'websysList_HasNestedData': websysListHasNestedData,
			
			/* Not implemented */
			'SelectRow': selectRow,
			'setRowClass': emptyFunction,
			'EPR_SelectEpisode': emptyFunction,
			'EPR_SelectEpisodeDetails': emptyFunction,
			'EPR_SaveSelectedEpisode': emptyFunction,
			'EPR_ClearSelectedEpisode': emptyFunction,
			'EPR_GotoShortcutMenu': emptyFunction,
			'websysListTable_AttachEvents': emptyFunction,
			'setRowSelected': setRowSelected,
			'setRowClear': setRowClear
		};
		
		return websysListFunctions;
	};
});
